import { render, staticRenderFns } from "./PositionMenu.vue?vue&type=template&id=5c1e9a05"
import script from "./PositionMenu.vue?vue&type=script&lang=js"
export * from "./PositionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports